import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Popper } from "@mui/material";
import { color } from "../../../../../shared/styles";
import Calendar from "../../../../../shared/svg/Calendar";
import dayjs, { Dayjs } from "dayjs";
import '../../../../../utils/dateUtils';

interface DueDateProps {
    dueDate: any;
    setDueDate: (value: string) => void;
}

const DueDate = ({ dueDate, setDueDate }: DueDateProps) => {
    // Parse the date value properly, handling both string and Date inputs
    const parsedDate = dueDate ? dayjs(dueDate) : null;
    
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
            <DemoContainer
                components={["DatePicker"]}
                sx={{ paddingTop: "0px" }}
            >
                <DatePicker
                    value={parsedDate}
                    onChange={(newValue: any) => {
                        setDueDate(newValue?.format("YYYY-MM-DD"));
                    }}
                    format="DD/MM/YYYY"
                    slotProps={{
                        textField: {
                            placeholder: "DD/MM/YYYY",
                        }
                    }}
                    dayOfWeekFormatter={(date: Dayjs) => {
                        const weekdaysShort = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
                        return weekdaysShort[date.day()];
                    }}
                    sx={{
                        width: "100%",
                        "& .MuiInputBase-root": {
                            height: "40px",
                            fontSize: "16px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            fontFamily: "Noto Sans",
                        },
                        "& .MuiInputBase-input": {
                            padding: "0px",
                        },

                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                border: "none",
                                borderRadius: "0px",
                                borderBottom: `2px solid ${color.secondary.BORDER}`,
                            },
                            "&:hover fieldset": {
                                border: "none",
                                borderBottom: `2px solid ${color.secondary.BORDER}`,
                            },
                            "&.Mui-focused fieldset": {
                                border: "none",
                                borderBottom: `2px solid ${color.secondary.BORDER}`,
                            },
                        },
                    }}
                    slots={{
                        popper: (props) => (
                            <Popper
                                {...props}
                                anchorEl={props.anchorEl}
                                placement="bottom-end"
                                sx={{
                                    zIndex: 1300,
                                    "& .MuiPickersLayout-root": {
                                        "& .MuiPickersDay-root[aria-selected='true']":
                                            {
                                                backgroundColor:
                                                    color.primary.BLUE_B100,
                                            },
                                    },
                                }}
                            />
                        ),
                        openPickerIcon: Calendar,
                    }}
                />
            </DemoContainer>
        </LocalizationProvider>
    );
};

export default DueDate;
